import { delay, getAIEmployerTiming } from '../../mock.config';
import questions from '../data/questions.json';

/* ── In-memory state ───────────────────────────────────────────────────── */
let questionsList = JSON.parse(JSON.stringify(questions));

const clone = (obj) => JSON.parse(JSON.stringify(obj));

export function resetQuestionState() {
  questionsList = JSON.parse(JSON.stringify(questions));
}

export function addQuestion(q) {
  questionsList = [q, ...questionsList];
}

export async function handleQuestionRequest(method, url, config) {
  const timing = getAIEmployerTiming();
  await delay(timing.apiDelay);

  // GET /board/:bid/tasks/:tid/human-in-loop — task-level questions
  if (method === 'GET' && /\/tasks\/[^/]+\/human-in-loop/.test(url)) {
    const statusParam = config?.params?.status;
    const statuses = statusParam ? statusParam.split(',') : null;
    let filtered = clone(questionsList);
    if (statuses) {
      filtered = filtered.filter((q) => statuses.includes(q.status));
    }
    return { status: true, body: { questions: filtered } };
  }

  // POST /board/:bid/human-in-loop/:qid/answer — submit answer
  if (method === 'POST' && /\/human-in-loop\/[^/]+\/answer/.test(url)) {
    const qid = url.split('/human-in-loop/')[1]?.split('/')[0];
    const body = JSON.parse(config?.data || '{}');
    const idx = questionsList.findIndex((q) => q._id === qid);
    if (idx >= 0) {
      questionsList[idx] = {
        ...questionsList[idx],
        status: 'answered',
        answer: {
          text: body.answer || '',
          choiceValue: body.choiceValue || null,
          fileUrls: body.fileUrls || [],
          answeredAt: new Date().toISOString(),
        },
      };
      return { status: true, message: 'Answer submitted', body: clone(questionsList[idx]) };
    }
    return { status: false, message: 'Question not found' };
  }

  // GET /user/human-in-loop/pending — global pending across all boards
  if (method === 'GET' && url.includes('/user/human-in-loop/pending')) {
    const pending = clone(questionsList).filter((q) => q.status === 'pending');
    return { status: true, body: { questions: pending, count: pending.length } };
  }

  // GET /board/:bid/human-in-loop — board-level pending (aggregated)
  if (method === 'GET' && /\/board\/[^/]+\/human-in-loop$/.test(url)) {
    const pending = clone(questionsList).filter((q) => q.status === 'pending');
    return { status: true, body: { questions: pending } };
  }

  // GET /board/:bid/human-in-loop/:qid — single question detail
  if (method === 'GET' && /\/human-in-loop\/[^/]+$/.test(url)) {
    const qid = url.split('/human-in-loop/')[1]?.split(/[/?]/)[0];
    const question = questionsList.find((q) => q._id === qid);
    if (question) return { status: true, body: clone(question) };
    return { status: false, message: 'Question not found' };
  }

  return { status: false, message: 'Unknown question endpoint: ' + method + ' ' + url };
}
